import { EventEmitter, Output, SimpleChanges } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { CustomerUser } from '@src/app/models/customeruser';
import { CustomerusereditService } from './service/customeruseredit.service';
import { Auth } from 'aws-amplify';
import { SessionHelper } from '@src/app/helpers/sessionHelper';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-customeruseredit',
  templateUrl: './customeruseredit.component.html',
  styleUrls: ['./customeruseredit.component.css']
})
export class CustomerusereditComponent implements OnInit {
  @Input() user: CustomerUser;
  @Output() errorMessage:string;
  @Output() changeduser = new EventEmitter<CustomerUser>();
  formIsValid:boolean;
  constructor(private cuesrv:CustomerusereditService) { }

  ngOnInit() {
    if(this.user == null){
      this.user = new CustomerUser;
    }
    this.validate();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.user){
      this.user = changes.user.currentValue || new CustomerUser();
     //console.log('user changed',this.user);
      this.validate();
    }
  } 
  toggleActive(){
    if(this.user.isactive==false){
      this.user.sendinvite = false;
    }
  }
  saveUser(){
  //console.log('save user',this.user);
   this.user.organizationId = SessionHelper.getChoosenOrg();
    this.cuesrv.editCustomerUser(this.user).pipe(untilDestroyed(this)).subscribe(result =>{
      this.user.userId = result;
      this.changeduser.emit(this.user);
      
      //console.log('user saved',result);
    }),error =>{
      this.errorMessage = error.error;
    };
      
  }
  validate(){
    const currentUser = this.user;
    if (!currentUser) {
      this.formIsValid = false;
      return;
    }

    if(
      currentUser.fullname &&
      currentUser.jobtitle &&
      currentUser.email &&
      currentUser.email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      ) &&
      currentUser.username
      )
      {
      this.formIsValid = true;
    }else{
      this.formIsValid = false;
    }
  }

}
